import { Card } from 'antd';
import type { ReactNode } from 'react';
import { Navigate } from 'react-router';

import type { Role } from '../enum';
import { validateAsFirstAlertsRole, validateAsSPManagerRole } from '../helpers/utils.helper';
import { useAppSelector } from '../hooks';

export const RequireAuth = ({ requiredRoles, children }: { requiredRoles: Role[]; children: ReactNode }) => {
  const authResult = useAppSelector((state) => state.authSlice.authResult);
  const currentUserRole = useAppSelector((state) => state.authSlice.currentUser.role);
  const userHasRequiredRole = currentUserRole && requiredRoles.includes(currentUserRole);
  const isFirstAlerts = validateAsFirstAlertsRole(currentUserRole);
  const isServiceProviderManager = validateAsSPManagerRole(currentUserRole);

  if (authResult.token && userHasRequiredRole) {
    return children;
  } else if (isFirstAlerts) {
    return <Navigate to="/page/alerts" />;
  } else if (isServiceProviderManager) {
    return <Navigate to="/page/admin-service-providers" />;
  } else if (authResult.token) {
    return (
      <Card title="Page not found">
        <p>Please select a page from the navigation bar on the left.</p>
      </Card>
    );
  }

  return <Navigate to="/login" />;
};
